import React from 'react'

export default function title({title}) {
    return (
        <div className="section-title"> 
            <h4>{title}</h4>
            <div />
        </div>
    )
}
